/**
 * Identificador de categoria para URLs e âncoras: sem acentos, minúsculas,
 * palavras unidas por "_".  "Epilação à Linha" → "epilacao_a_linha".
 *
 * É a única versão usada pelas páginas — a página inicial gera links para a
 * de Serviços, por isso as duas têm de produzir exatamente o mesmo texto.
 */
export const slugify = (str = '') =>
  str
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '')

export default slugify
